import { HttpHeaders } from '@angular/common/http';
import { normalizeVaultTenantId } from './vault-tenant-scope.util';
import {
  resolveVaultActiveTenantId,
  shouldSendVaultXTenantHeader,
} from './vault-active-tenant.util';
import { vaultUserIsSuperadminFromSession } from './vault-user-roles.util';

function isAdminUsersApiUrl(path: string): boolean {
  return path.includes('/api/admin/users');
}

/** Endpoints de bootstrap de sesión: sin `X-Tenant-ID` ni scope tenant (DEV 57a9287). */
export function shouldSkipVaultTenantHeaderForUrl(url: string): boolean {
  const path = (url || '').split('?')[0];
  if (
    path.includes('/api/auth/me') ||
    path.includes('/api/auth/logout') ||
    path.includes('/api/auth/change-password') ||
    path.includes('/api/auth/profile') ||
    path.includes('/api/tenants/my-tenants') ||
    path.includes('/refresh')
  ) {
    return true;
  }
  /**
   * Superadmin: gestión de usuarios usa `tenant_id` en query/body.
   * Evita enviar `X-Tenant-ID` de otra empresa activa en sesión (crear/editar/listar).
   */
  if (isAdminUsersApiUrl(path) && vaultUserIsSuperadminFromSession()) {
    return true;
  }
  return false;
}

/** Valor para cabecera `X-Tenant-ID` (tenant activo de sesión, solo UUID válido). */
export function resolveVaultXTenantHeaderValue(tenantId?: string): string {
  const raw = (tenantId || resolveVaultActiveTenantId() || '').trim();
  return normalizeVaultTenantId(raw) || '';
}

/**
 * Cabeceras Vault con `X-Tenant-ID` solo cuando aplica (DEV 57a9287):
 * - Superadmin con empresa activa, o
 * - Usuario que cambió la empresa activa (una sola a la vez).
 * Usuario con 1 asignación sin cambio: sin cabecera.
 */
export function vaultTenantHeaders(tenantId?: string, requestUrl?: string): HttpHeaders {
  if (requestUrl && shouldSkipVaultTenantHeaderForUrl(requestUrl)) {
    return new HttpHeaders();
  }
  if (!shouldSendVaultXTenantHeader()) {
    return new HttpHeaders();
  }
  const value = resolveVaultXTenantHeaderValue(tenantId);
  if (!value) {
    return new HttpHeaders();
  }
  return new HttpHeaders({ 'X-Tenant-ID': value });
}

/** Añade `X-Tenant-ID` a un mapa de cabeceras plano (interceptor). */
export function applyVaultXTenantHeader(
  headers: Record<string, string>,
  requestUrl?: string,
  tenantId?: string,
): void {
  if (requestUrl && shouldSkipVaultTenantHeaderForUrl(requestUrl)) return;
  if (!shouldSendVaultXTenantHeader()) return;
  const value = resolveVaultXTenantHeaderValue(tenantId);
  if (value) {
    headers['X-Tenant-ID'] = value;
  }
}
